import { handleResponse, SERVER_HOST } from "@api";
import { TAsset, TAssetGroup, TAssetService, TBookingOrder, TBookNow, TCreateBooking, TImage, TSlot } from "@components/types";
import { imageCompressorFunc } from "@core/utils";
import axios from "axios";

export const getDetailAsset = async (id: number | string) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/assets/${id}`)
    const result: TAsset = await res.json()
    return result;
}

export const getDetailAssetGroup = async (id: number | string) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/assetgroupdetail/${id}`,
        // { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } }
    )
    const result: TAsset = await res.json()
    return result;
}

export const getAssetGroups = async (storeId: number, name: string = null, pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    if (storeId > 0) {
        const res = await axiosMethod(`${SERVER_HOST}/api/v1/assetgroup/?store_id=${storeId}${name?.length > 0 ? `&name=${name}` : ""}&skip=${pageNumber * pageSize}&limit=${pageSize}`,
            { headers: { "Content-Type": "application/json" } })
        return handleResponse(res);
    }
}

export const getAssetGroupById = async (id: number) => {
    let axiosMethod = axios.get;
    if (id > 0) {
        const res = await axiosMethod(`${SERVER_HOST}/api/v1/assetgroup/${id}`,
            { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
        return handleResponse(res);
    }
}

export const getAssets = async (storeId: number, name: string = null, asset_group_id: number = null, pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    if (storeId > 0) {
        const res = await axiosMethod(`${SERVER_HOST}/api/v1/assets/?store_id=${storeId}${name?.length > 0 ? `&name=${name}` : ""}${asset_group_id > 0 ? `&asset_group_id=${asset_group_id}` : ""}&skip=${pageNumber * pageSize}&limit=${pageSize}`,
            { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
        return handleResponse(res);
    }
}

export const addAssetGroup = async (assetGroup: TAssetGroup) => {
    let axiosMethod = assetGroup?.id > 0 ? axios?.put : axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/assetgroup/${assetGroup?.id > 0 ? assetGroup?.id : ''}`, JSON.stringify(assetGroup),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const addAsset = async (asset: TAsset) => {
    let axiosMethod = asset?.id > 0 ? axios?.put : axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/assets/${asset?.id > 0 ? asset?.id : ''}`, JSON.stringify(asset),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const addBooking = async (booking: TCreateBooking) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/create`, JSON.stringify(booking),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const createWebCheckInLink = async (booking_id: number, store_id: number, contact: string, valid_time_hours: number = 24) => {
    if (!Number.isInteger(store_id) || store_id <= 0) {
        throw new Error('The booking is missing its property. Please refresh and try again.');
    }
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/web_checkin/?booking_id=${booking_id}&store_id=${store_id}&contact=${contact}&valid_time_hours=${valid_time_hours}`, JSON.stringify({}),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const webCheckIn = async (encryptedBooking: string) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/web/check-in?encrypt=${encodeURIComponent(encryptedBooking)}`, JSON.stringify({}),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

// Mints an encrypted, time-boxed link for the booking owner to share with
// co-travellers (self check-in). Server checks current_user.id === booking's customer_id.
export const createGuestInviteLink = async (bookingId: number, validTimeHours: number = 24) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/create/link?booking_id=${bookingId}&valid_time_hours=${validTimeHours}`, JSON.stringify({}),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

// Book Now
export const bookNow = async (booking: TBookNow) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/booknow`, JSON.stringify(booking),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const modifyBooking = async (booking: TBookNow) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/modify/`, JSON.stringify(booking),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const updateBooking = async (booking: any) => {
    let axiosMethod = axios?.put;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/${booking?.id}`, JSON.stringify(booking),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}


export const getAssetBookings = async (storeId: number = null, status: string[] = [], user_id: number = null, asset_id: number = null, customer: string = null, assetgroup: string = null, asset: string = null, pageNumber: number = 0, pageSize: number = 20, start_date: string = null, end_date: string = null, sid: string = null, uid: string = null) => {
    let axiosMethod = axios.get;
    let params: any = new URLSearchParams();
    let SERVER_HOST = "https://business.jhattse.com"
    if (storeId > 0) {
        params?.append('store_id', storeId?.toString());
    }
    if (asset_id > 0) {
        params?.append('asset_id', asset_id?.toString());
    }
    if (assetgroup?.length > 0) {
        params?.append('assetgroup', assetgroup);
    }
    if (user_id > 0) {
        params?.append('user_id', user_id?.toString());
    }
    if (customer?.length > 0) {
        params?.append('owner_id', user_id?.toString());
    }
    if (sid?.length > 0) {
        params?.append('sid', sid?.toString());
    }
    if (uid?.length > 0) {
        params?.append('uid', uid?.toString());
    }
    if (status?.length > 0) {
        params?.append('status', status?.toString());
    }
    if (start_date !== null) {
        params?.append('start_date', start_date?.toString());
    }
    if (end_date !== null) {
        params?.append('end_date', end_date?.toString());
    }
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/?${params}&skip=${pageNumber * pageSize}&limit=${pageSize}&ascending=false`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}



// Asset Images
export const addAssetImage = async (file: File, asset_id: number = null, type: string = 'other') => {
    const formData = new FormData();
    formData.append('file', file, file?.name);
    formData.append('asset_id', asset_id?.toString());
    formData.append('type', type || 'other');
    formData.append('description', 'NA');

    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/assetimages/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const updateAssetImage = async (image: TImage, id: number) => {
    let axiosMethod = axios.put;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/assetimages/${id}`,
        JSON.stringify(image),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const removeAssetImages = async (id: number) => {
    const res = await axios.delete(`${SERVER_HOST}/api/v1/assetimages/${id}`, {
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
    })
    const result = handleResponse(res);
    return result;
}

// Get Slots
export const getSlots = async (storeId: number, name: string = null, asset_group_ids: number[] = [], asset_id: number = null, day_of_week: number = null, pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    let params: any = new URLSearchParams();
    params?.append('store_id', storeId?.toString());
    if (asset_id > 0) {
        params?.append('asset_id', asset_id?.toString());
    }
    if (name?.length > 0) {
        params?.append('name', name?.toString());
    }
    if (day_of_week !== null) {
        params?.append('day_of_week', day_of_week?.toString());
    }
    if (asset_group_ids?.length > 0) {
        for (let i = 0; i < asset_group_ids.length; i++) {
            params.append('asset_group_id', asset_group_ids[i]);
        }
    }
    params?.append('skip', pageNumber * pageSize);
    params?.append('limit', pageSize);
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/assetgroup/slots/?${params}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const getAvailableSlots = async (storeId: number, asset_group_ids: number[] = [], asset_ids: number[] = [], start_date: string, end_date: string, pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    let params: any = new URLSearchParams();
    params?.append('store_id', storeId?.toString());
    params?.append('start_date', start_date);
    params?.append('end_date', end_date);
    if (asset_ids?.length > 0) {
        for (let i = 0; i < asset_ids.length; i++) {
            params?.append('asset_id', asset_ids[i]);
        }
    }
    if (asset_group_ids?.length > 0) {
        for (let i = 0; i < asset_group_ids.length; i++) {
            params.append('asset_group_id', asset_group_ids[i]);
        }
    }
    params?.append('skip', pageNumber * pageSize);
    params?.append('limit', pageSize);
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/slots/available?${params}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const addSlot = async (slot: TSlot) => {
    let axiosMethod = slot?.id > 0 ? axios?.put : axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/slots/${slot?.id > 0 ? slot?.id : ''}`, JSON.stringify(slot),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const addMultiSlots = async (slots: TSlot[]) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/slots/multi`, JSON.stringify(slots),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const deleteSlot = async (id: number) => {
    let axiosMethod = axios.delete;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/slots/${id}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

// Check Availability
export const checkAvailability = async (storeId: number = null, asset_group_id: number = null, asset_id: number = null, start_date: string = null, end_date: string = null, pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/assets/availability?store_id=${storeId}${asset_id > 0 ? `&asset_id=${asset_id}` : ""}${asset_group_id > 0 ? `&asset_group_id=${asset_group_id}` : ""}${start_date !== null ? `&start_time=${start_date}` : ""}${end_date !== null ? `&end_time=${end_date}` : ""}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

// Check Availability
export const checkAssetGroupAvailability = async (storeId: number = null, asset_group_ids: number[] = [], inventory_ids: number[] = [], start_date: string = null, end_date: string = null, pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    let params: any = new URLSearchParams();
    params?.append('store_id', storeId?.toString());
    params?.append('start_time', start_date);
    params?.append('end_time', end_date);
    if (asset_group_ids?.length > 0) {
        for (let i = 0; i < asset_group_ids.length; i++) {
            params.append('asset_group_id', asset_group_ids[i]);
        }
    }
    if (inventory_ids?.length > 0) {
        for (let i = 0; i < inventory_ids?.length; i++) {
            params.append('inventory_id', inventory_ids[i]);
        }
    }
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/assetgroup/availability/?${params}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}


// Check Availability
export const checkStayAvailability = async (storeId: number = null, asset_group_ids: number[] = [], inventory_ids: number[] = [], start_date: string = null, end_date: string = null, guest_count: number = null, child_count: number = null) => {
    let axiosMethod = axios.get;
    let params: any = new URLSearchParams();
    params?.append('property_id', storeId?.toString());
    if (guest_count > 0) {
        params?.append('guest_count', guest_count.toString());
    }
    if (child_count > 0) {
        params?.append('child_count', child_count.toString());
    }
    params?.append('start_date', start_date);
    params?.append('end_date', end_date);
    if (asset_group_ids?.length > 0) {
        for (let i = 0; i < asset_group_ids.length; i++) {
            params.append('room_category_id', asset_group_ids[i]);
        }
    }
    if (inventory_ids?.length > 0) {
        for (let i = 0; i < inventory_ids?.length; i++) {
            params.append('inventory_id', inventory_ids[i]);
        }
    }
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/engine/schedule/?${params}`,
        { headers: { "Content-Type": "application/json" } })
    return handleResponse(res);
}

// Get Booking by Id
export const getBookingById = async (id: number, token: string = null) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/${id}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token != null ? token : typeof window !== "undefined" && localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const deleteBookingById = async (id: number) => {
    const res = await axios.delete(`${SERVER_HOST}/api/v1/bookings/${id}`, {
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` },
    });
    return handleResponse(res);
}

// Get Booking by Id
export const getBookingPaymentStatus = async (transaction_id: string) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/payment/status?transaction_id=${transaction_id}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

// Services Apis
export const getServices = async (storeId: number, asset_group_id: number = null, asset_id: number = null, pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/services/?store_id=${storeId}${asset_group_id > 0 ? `&asset_group_id=${asset_group_id}` : ""}${asset_id > 0 ? `&asset_id=${asset_id}` : ""}&skip=${pageNumber * pageSize}&limit=${pageSize}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const addService = async (service: TAssetService) => {
    let axiosMethod = service?.id > 0 ? axios?.put : axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/services/${service?.id > 0 ? service?.id : ''}`, JSON.stringify(service),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const getAssetServiceById = async (id: number) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/services/${id}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const removeAssetService = async (id: number) => {
    const res = await axios.delete(`${SERVER_HOST}/api/v1/services/${id}`, {
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
    })
    const result = handleResponse(res);
    return result;
}

// Inventory Service
export const getInventoryServices = async (storeId: number, asset_group_ids: number[] = [], asset_ids: number[] = [], pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    let params: any = new URLSearchParams();
    if (storeId > 0) {
        params?.append('store_id', storeId);
    }
    if (asset_group_ids?.length > 0) {
        for (let i = 0; i < asset_group_ids.length; i++) {
            if (asset_group_ids[i] !== undefined && asset_group_ids[i] !== null) {
                params.append('asset_group_id', asset_group_ids[i]);
            }
        }
    }
    if (asset_ids?.length > 0) {
        for (let i = 0; i < asset_ids?.length; i++) {
            if (asset_ids[i] !== undefined && asset_ids[i] !== null) {
                params.append('asset_id', asset_ids[i]);
            }
        }
    }
    params?.append('skip', pageNumber * pageSize);
    params?.append('limit', pageSize);
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/inventories/services/?${params}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const getAddonServices = async (storeId: number, isLive: boolean = true, pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    let params: any = new URLSearchParams();
    params?.append('store_id', storeId);
    params?.append('is_live', isLive);
    params?.append('skip', pageNumber * pageSize);
    params?.append('limit', pageSize);
    params?.append('is_service', true)
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/inventories/?${params}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const getAssetServiceInventoryId = async (id: number) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/inventories/${id}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}


// export booking payment breakup
export const createBookingPaymentBreakup = async (booking: TCreateBooking) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/bookings/breakup`, JSON.stringify(booking),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

// Pricing Plans
export const getPricingPlans = async (name: string = null, pageNumber: number = 0, pageSize: number = 20) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/pricingplans/?skip=${pageNumber * pageSize}&limit=${pageSize}${name?.length > 0 ? `&name=${name}` : ""}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${typeof window !== "undefined" && localStorage.getItem("token")}` } })
    return handleResponse(res);
}

//  Get payment status
export const getPaymentStatus = async (transaction_id: string) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/ordertransactions/payment/status?transaction_id=${transaction_id}`,
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${typeof window !== "undefined" && localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const addBookingOrder = async (booking: TBookingOrder) => {
    let axiosMethod = axios.post;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/orders/tag/booking`, JSON.stringify(booking),
        { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` } })
    return handleResponse(res);
}

export const uploadImage = async (file: File, path: string = "brand", options: { skipCompression?: boolean } = {}) => {
    let axiosMethod = axios.post;
    const formData = new FormData();
    const compressedFile = options.skipCompression ? file : await imageCompressorFunc(file);
    formData.append('files', compressedFile, compressedFile.name);
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/file/upload/?path=${path}`,
        formData, { headers: { "Content-Type": "multipart/form-data" } }
    );

    return handleResponse(res);
}

export const createServiceRequest = async (payload: {
    asset_id?: number | null;
    store_id?: number;
    category_id: number;
    description: string;
    status?: string;
    owner_id?: number
}) => {
    const res = await axios.post(
        `${SERVER_HOST}/api/v1/assettasks/`,
        JSON.stringify(payload),
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        }
    );
    return handleResponse(res);
};

export const updateServiceRequest = async (id: number, payload: { description?: string; category_id?: number; status?: string }) => {
    const res = await axios.put(
        `${SERVER_HOST}/api/v1/assettasks/${id}`,
        JSON.stringify(payload),
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        }
    );
    return handleResponse(res);
};

export const getServiceRequests = async (params: {
    asset_id?: number | null;
    store_id?: number;
    page?: number;
    page_size?: number;
    owner_id?: number;
    is_completed?: boolean;
}) => {
    const query = new URLSearchParams();
    if (params.asset_id) query.append('asset_id', String(params.asset_id));
    if (params.store_id) query.append('store_id', String(params.store_id));
    if (params.page) query.append('page', String(params.page));
    if (params.page_size) query.append('page_size', String(params.page_size));
    if (params.owner_id) query.append('owner_id', String(params.owner_id));
    if (params.is_completed !== undefined) query.append('is_completed', String(params.is_completed));
 
    const res = await axios.get(
        `${SERVER_HOST}/api/v1/assettasks/?${query.toString()}`,
        {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        }
    );
    return handleResponse(res);
};
